import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'

export default function getConstants(p = {}) {

    const { name = 'image' } = p

    const n = name
    const N = capitalize(n)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Mentés',
            ['restore' + N + 'SubmitLabel']: 'Visszaállítás',
            ['save' + N + 'SubmitLabel']: 'Mentés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'Képek törlése',
            ['ban' + N + 'Text']: 'Tiltás',
            ['approve' + N + 'Text']: 'Jóváhagyás',
            ['protection' + N + 'Text']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Text']: 'Védettség megszüntetése',
            ['select' + N + 'Text']: 'Kiválasztás',
            ['add' + N + 'Text']: 'Hozzáadás',

            [ns + 'SortRelevance']: 'Relevancia',

            ['cancelAbortUpload' + Ns + 'Text']: 'Mégsem',
            ['abortUpload' + Ns + 'Text']: 'Megszakítás',
            ['upload' + Ns + 'HelperText']: 'Kattints vagy húzd ide a képeket',
            ['upload' + N + 'HelperText']: 'Kattints vagy húzd ide a képet',
            [n + 'GalleryMoreItems']: ({ length }) => '+' + length + ' további kép',
            [n + 'GalleryAlt']: ({alt, index, type})=>{
                if (type === 'image') {
                    return alt ? [alt, `(${['Kép', index].filter((t)=>t).join(' ')})`].join(' ') : ''
                } else if (type === 'video') {
                    return alt ? `Videó: ${alt}` : ''
                }
                return ''
            },

            [ns + 'OrSelectFromListOpenLabel']: 'Médiatár',

            [n + 'CoverPropsRotateLabel']: 'Forgatás',
            [n + 'CoverPropsScaleLabel']: 'Nagyítás',

            [n + 'AvatarPropsRotateLabel']: 'Forgatás',
            [n + 'AvatarPropsScaleLabel']: 'Nagyítás'

        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'Képek',
            ['my' + Ns + 'Menu']: 'Képeim',
            ['new' + N + 'Menu']: 'Képek feltöltése',
            [ns + 'Menu']: 'Képek',
            ['deleted' + Ns + 'Menu']: 'Törölt képek',
            ['banned' + Ns + 'Menu']: 'Véglegesen törölt képek',
            ['protection' + Ns + 'Menu']: 'Védett képek',
            ['missingData' + Ns + 'Menu']: 'Hiányzó adatok',
            ['lowAuthorStatus' + Ns + 'Menu']: 'Szerző alacsony státusszal',

            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés',
            ['ban' + N + 'Menu']: 'Tiltás',
            ['approve' + N + 'Menu']: 'Jóváhagyás',
            ['protection' + N + 'Menu']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Menu']: 'Védettség törlése'
        },
        messages: {
            ...messages,
            ['new' + Ns + 'SuccessMessage']: 'Képek feltöltve',
            ['save' + N + 'SuccessMessage']: 'A kép mentésre került',
            ['delete' + N + 'Success']: 'A kép törölve lett',
            ['delete' + Ns + 'Success']: 'A képek törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törli a képet?',
            ['delete' + Ns + 'Question']: 'Biztosan törli a képeket?',
            ['ban' + N + 'Success']: 'A kép véglegesen törölve lett',
            ['ban' + N + 'Question']: 'Biztos, hogy a képet véglegesen törölni akarod?',
            ['approve' + N + 'Success']: 'A kép jóvá lett hagyva',
            ['approve' + N + 'Question']: 'Biztosan jóváhagyod a képet',
            ['protection' + N + 'Success']: 'A kép védettnek jelölve',
            ['protection' + N + 'Question']: 'Biztosan védettnek jelölöd a képet?',
            ['removeProtection' + N + 'Success']: 'A védettnek jelölés törölve lett',
            ['removeProtection' + N + 'Question']: 'Biztosan törlöd a védettnek jelölést?',
            ['thereAreNo' + Ns]: 'Nincsenek képek',

            ['abortUpload' + Ns + 'Question']: 'Megszkítod a feltöltést?',
            ['abortUpload' + Ns + 'Success']: 'Feltöltés megszakítva',
            ['new' + Ns + 'ClientErrorMessage']: 'Hiba történt a kép megnyitásakor, próbáld újratölteni az oldalt'
        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Kép',
            [ns + 'Title']: 'Képek',
            ['new' + N + 'Title']: 'Új kép',
            ['edit' + N + 'Title']: 'Kép szerkesztése',
            ['user' + Ns + 'Title']: 'Képek',
            ['userDeleted' + Ns + 'Title']: 'Törölt képek',
            ['userBanned' + Ns + 'Title']: 'Véglegesen törölt képek',
            ['my' + Ns + 'Title']: 'Képeim',
            ['myDeleted' + Ns + 'Title']: 'Törölt képeim',
            ['myBanned' + Ns + 'Title']: 'Véglegesen törölt képeim',

            ['dialogDelete' + N + 'Title']: 'Kép törlése',
            ['dialogBan' + N + 'Title']: 'Kép törlése véglegesen',
            ['dialogApprove' + N + 'Title']: 'Kép jóváhagyása',
            ['dialogProtection' + N + 'Title']: 'Kép védettnek jelölése',
            ['dialogRemoveProtection' + N + 'Title']: 'Kép védettségének megszüntetése',

            ['dialogDelete' + Ns + 'Title']: 'Képek törlése',
            ['dialogAbortUpload' + Ns + 'Title']: 'Feltöltés megszakítása',

            ['statusBanned' + N + 'Title']: 'Véglegesen törölt',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Védett',
            ['statusCreated' + N + 'Title']: 'Létrehozva',

            ['banned' + Ns + 'Title']: 'Véglegesen törölt képek',
            ['deleted' + Ns + 'Title']: 'Törölt képek',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok',
            ['protected' + Ns + 'Title']: 'Védett képek',
            ['lowAuthorStatus' + Ns + 'Title']: 'Szerző alacsony státusszal',

            ['select' + Ns]: 'Képek kiválasztása',
            ['select' + N]: 'Kép kiválasztása'
        }
    }
}
